import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '../../../../src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UploadImageData, UploadStatus } from 'globals/store/files.model';

    import { deleteObject, getStorage, ref } from "firebase/storage";
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'logo-handler',
    template: `
@if(!text){
  <div class="logo_content">
    <div class="shadow"></div>
    @if(!uploading){
      <div class="upload_panel">
        <label for="logo-file"><icon matIcon="camera_alt"></icon></label>
        <input type="file" id="logo-file" hidden (change)="onFileChange($event)" />
      </div>
    }
  </div>
}@else{
  <div class="text">
    <button mat-button class="plain"><label [attr.for]="uniqueFormIdentifier" [innerHTML]="text"></label></button>
    <input type="file" [attr.id]="uniqueFormIdentifier" hidden (change)="onFileChange($event)" />
  </div>
}
    `,
    styleUrls: ['./file-handler.component.scss'],
    imports: [IconComponent, MatButtonModule, CommonModule],
    standalone: true,
})
export class LogoHandlerComponent implements OnInit {

  @Input() text
  @Input() uniqueFormIdentifier // this is like an id so you can have multiple ones on the page at the same time
  @Input() imageData: UploadImageData
  @Input() maxSize
  @Input() public
  @Input() publishCode: string = null
  @Output() uploadStatusChanged: EventEmitter<UploadStatus> = new EventEmitter()

  uploading = false;
  @Input() api = `${environment.functionsURL}api/app` // need to be able to set to "v1" for public

  constructor(
    private http: HttpClient,
  ) { }

  ngOnInit() { 
    if (this.public) this.api = `${environment.functionsURL}api/v1`
    // console.log({ api: this.api })
  }

  async deletePhotoFromUrl(photoUrl) {
    const storage = getStorage();
    const fileRef = ref(storage, photoUrl);
    this.uploading = true
    this.uploadStatusChanged.emit({ state: 'uploading' })
    await deleteObject(fileRef);
    this.uploading = false
    this.uploadStatusChanged.emit({ state: 'uploaded' })
  }

  async onFileChange(evt: any) {
    let targetFile: File;
    if (evt.dataTransfer && evt.dataTransfer.files.length === 1) {
      targetFile = evt.dataTransfer.files[0];
      evt.dataTransfer.files = null
    } else if (evt.target.files && evt.target.files.length === 1) {
      targetFile = evt.target.files[0];
      evt.target.files = null
    } else {
      throw new Error('Cannot use multiple files');
    }
    if (this.maxSize && targetFile.size > this.maxSize) {
      return this.uploadStatusChanged.emit({ state: 'exceedsMaxSize' })
    }
    if (!targetFile || !/^image\//.test(targetFile.type)) {
      return this.uploadStatusChanged.emit({ state: 'invalidFile' })
    }
    evt.target.value = null
    try {
      this.uploadStatusChanged.emit({ state: 'uploading' })
      const formData: FormData = new FormData()
      formData.append('publishCode', this.publishCode)
      formData.append('fileType', targetFile.type)

      this.imageData['fakeBool'] = false
      Object.entries(this.imageData).forEach(([k, v]) => {
        // console.log({ key, value })
        const key = k as keyof UploadImageData // typing to ensure an invalid data type like boolean is not being force converted
        const value: UploadImageData[typeof key] = v // typing to ensure an invalid data type like boolean is not being force converted
        formData.append(key, value)
      })

      const formImageData = {}
      Object.keys(this.imageData).forEach(key => formImageData[key] = formData.get(key))
      console.log({ imageData: this.imageData, formImageData })

      formData.append('image', targetFile, targetFile.name)
      const response = await this.http.post(`${this.api}/upload-image-binary`, formData).toPromise()
      const result = { ...response, state: 'uploaded', originalName: targetFile.name }
      this.uploadStatusChanged.emit(result as any)
    } catch (error) {
      console.log(error)
      this.uploadStatusChanged.emit({ state: 'error' })
    }
  }
}
